export const formConfig = [
  {
    type: "dimensionPicker",
    label: "Afmetingen",
    name: "DIMENSION",
    detailed_label: "Wat zijn de gewenste breedte en hoogte voor uw poort?",
    title: "Afmetingen",
    validation: {
      WIDTH: {
        required: "Breedte is verplicht",
        min: { value: 250, message: "Breedte moet minimaal 250cm zijn" },
        max: { value: 1000, message: "Breedte mag minimaal 1000cm zijn" },
      },
      HEIGHT: {
        required: "Hoogte is verplicht",
        min: { value: 100, message: "Hoogte moet minimaal 100cm zijn" },
        max: { value: 250, message: "Hoogte mag minimaal 250cm zijn" },
      },
    },
  },

  {
    type: "yesnoPicker",
    label: "Opmeting laten uitvoeren",
    name: "OPMETING",
    detailed_label: (
      <>
        Ik wens de opmeeting te laten uitvoeren zodat ik zeker ben van de maten{" "}
        <span className="text-blue-600">(Eénmalig +150 euro)</span>
      </>
    ),
    title: "Controle opmeting",
    validation: {},
  },
  {
    title: "Soort hout",
    detailed_label: "Uit welk materiaal wenst u uw poort te maken?",
    name: "FRAME_COLOR",
    label: "Kleur van het frame",
    type: "colorPicker",
    defaultValue: "OAK",
    options: [
      {
        label: "Blond eikenhout",
        file: "data/oak.jpg",
        color: "#f6f6f6",
        code: "OAK",
        priceFactor: 1.2
      },

      {
        label: "Aframosia",
        file: "data/4K_afromosia_basecolor.png",
        color: "#f6f6f6",
        code: "Afra",
        priceFactor: 1.3
      },
      {
        label: "Anigre",
        file: "data/1K-anigre_basecolor.png",
        color: "#f6f6f6",
        code: "Anigre",
        priceFactor: 1.1
      },

      {
        label: "Amerikaanse eik",
        file: "data/4K-american_oak_1_basecolor.png",
        color: "#f6f6f6",
        code: "Aoak",
        priceFactor: 1.5
      },

      {
        label: "Amerikaanse walnoot",
        file: "data/4K-american_walnut_1_basecolor.png",
        color: "#f6f6f6",
        code: "Awalnut",
        priceFactor: 1.7
      },


      
      
      

      
    ],
    validation: {
      required: "Gelieve een soort hout voor de poort te selecteren",
    },
  },
];
